import { Injectable } from '@angular/core';
import { ShareRecommendationData } from '@app/core/models/share-recommendation-data';
import { Store } from '@ngrx/store';
import { AppState } from '..';
import {
  requestGenerateNewRecommendationRandomId,
  resetRecommendationRandomIds,
  resetShareRecommendation,
  setDisplayVetComments,
  setShareRecommendation,
  setTargetWeightForWLP,
  setVetComments,
} from './share-recommendation.actions';
import {
  selectPetHasGrowthChart,
  selectRecommendationId,
  selectShareRecommendationData,
  selectShareRecommendationPetInfo,
} from './share-recommendation.selector';
import { SystemPreferenceCode } from '@app/shared/utils/enums/system-preference-code';

@Injectable()
export class ShareRecommendationFacade {
  public selectShareRecommendationData$ = this.store$.select(selectShareRecommendationData);
  public selectShareRecommendationPetInfo$ = this.store$.select(selectShareRecommendationPetInfo);
  public selectPetHasGrowthChart$ = (currentSystemPreferenceCode: SystemPreferenceCode) =>
    this.store$.select(selectPetHasGrowthChart(currentSystemPreferenceCode));
  public selectRecommendationId$ = (productIds: string[]) => this.store$.select(selectRecommendationId(productIds));

  constructor(private readonly store$: Store<AppState>) {}

  public setShareRecommendation(data: ShareRecommendationData): void {
    this.store$.dispatch(setShareRecommendation({ data }));
  }

  public resetShareRecommendation(): void {
    this.store$.dispatch(resetShareRecommendation());
  }

  public requestGenerateRandomRecommendationId(productIds: string[]): void {
    this.store$.dispatch(requestGenerateNewRecommendationRandomId({ productIds }));
  }

  public resetRecommendationRandomIds(): void {
    this.store$.dispatch(resetRecommendationRandomIds());
  }

  public setVetComments(vetComments: string): void {
    this.store$.dispatch(setVetComments({ vetComments }));
  }

  public setDisplayVetComments(displayVetComments: boolean): void {
    this.store$.dispatch(setDisplayVetComments({ displayVetComments }));
  }

  public setTargetWeightForWLP(targetWeight: number): void {
    this.store$.dispatch(setTargetWeightForWLP({ targetWeight }));
  }
}
